import { giftImageUrl } from '../../api/gifts';
import { GiftItem } from '../../types/gifts';

interface GiftCardProps {
    item: GiftItem;
    claiming: boolean;
    onClaim: (item: GiftItem) => void;
}

const LockIcon = () => (
    <svg className="gift-lock__icon" viewBox="0 0 24 24" width="22" height="22" fill="none" aria-hidden="true">
        <rect x="5" y="10" width="14" height="10" rx="2" fill="currentColor" />
        <path d="M8 10V7a4 4 0 0 1 8 0v3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
);

const CheckIcon = () => (
    <svg viewBox="0 0 24 24" width="12" height="12" fill="none" aria-hidden="true" style={{ marginRight: 3 }}>
        <path d="M5 12.5l4.5 4.5L19 7" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const GiftCard = ({ item, claiming, onClaim }: GiftCardProps) => {
    const isLocked = item.state === 'locked';
    const isClaimed = item.state === 'claimed';
    const imageUrl = giftImageUrl(item.image_path);

    const cardClass = ['gift-card', item.state === 'available' ? 'gift-card--available' : '']
        .filter(Boolean)
        .join(' ');

    return (
        <div className={cardClass}>
            <div className="gift-card__top">
                <span className="gift-card__month">{item.month_number} oy</span>
                {item.badge && <span className="gift-card__badge">{item.badge}</span>}
            </div>

            <div className="gift-card__title">{item.title}</div>

            <div className={`gift-card__image${isLocked ? ' is-locked' : ''}`}>
                {imageUrl ? (
                    <img className="gift-card__img" src={imageUrl} alt={item.title} loading="lazy" />
                ) : (
                    <div className="gift-card__img gift-card__img--empty" />
                )}
                {isLocked && (
                    <div className="gift-lock">
                        <LockIcon />
                    </div>
                )}
            </div>

            <button
                type="button"
                className={`gift-btn gift-btn--${item.state}`}
                disabled={isLocked || claiming}
                onClick={() => !isLocked && onClaim(item)}
            >
                {isLocked && 'YOPIQ'}
                {item.state === 'available' && (claiming ? '...' : 'OLISH')}
                {isClaimed && (
                    <>
                        <CheckIcon />
                        OLINGAN
                    </>
                )}
            </button>
        </div>
    );
};

export default GiftCard;
